import { SortBy } from "@features/products/domain";

export const SORT_BY_INTRODUCED_AT = SortBy.SORT_BY_INTRODUCED_AT;
export const SORT_BY_UPDATED_AT = SortBy.SORT_BY_UPDATED_AT;
export const SORT_BY_PRODUCT_PRICE = SortBy.SORT_BY_PRODUCT_PRICE;
export const SORT_BY_PRODUCT_PROFIT = SortBy.SORT_BY_PRODUCT_PROFIT;

export const ALL_PRODUCTS_CATEGORY =
  "PRODUCTS_PAGE.CAROUSEL_NAMES.ALL_PRODUCTS_CAROUSEL_NAME";
